<quill-editor [styles]="{ height: '250px' }" id="prescriptionBody" #editor [(ngModel)]="prescription.text"></quill-editor>
<div class="mt-2">
  <button (click)="searchPrescriptionTemplate()" class="btn btn-outline-primary float-left">Pesquisar receita</button>
  <button (click)="save()" [hidden]="detached" class="btn btn-primary float-right ml-1">Salvar</button>
  <button (click)="print()" [hidden]="!detached" class="btn btn-primary float-right ml-1">Imprimir</button>
  <button (click)="cancel()" class="btn btn-secondary float-right">{{ detached ? 'Fechar' : 'Cancelar' }}</button>
</div>

<!-- Modal -->
<div class="modal fade" #createNewModal tabindex="-1" role="dialog" aria-labelledby="createNewModal" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Pesquisar receita</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <mc-prescription-template-index [crudMode]="false" (selected)="selectedTemplate($event)"></mc-prescription-template-index>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
